import type { AppRemoteConfig } from '../../platform/Platform';
import { DEFAULT_REMOTE_CONFIG } from '../../firebase/defaultRemoteConfig';
import type {
  InterstitialStrategy,
  InterstitialStrategyContext,
  InterstitialStrategyState,
} from './InterstitialStrategy';
import { LegacyInterstitialStrategy } from './LegacyInterstitialStrategy';
import { RemoteConfigInterstitialStrategy } from './RemoteConfigInterstitialStrategy';

/**
 * Create the appropriate interstitial strategy based on whether to use remote config flow.
 * - useRemoteConfigFlow = false → LegacyInterstitialStrategy (Facebook/Web)
 * - useRemoteConfigFlow = true → RemoteConfigInterstitialStrategy (Capacitor)
 */
export function createInterstitialStrategy(
  useRemoteConfigFlow: boolean,
  context: InterstitialStrategyContext,
  state: InterstitialStrategyState,
  config?: AppRemoteConfig | null,
): InterstitialStrategy {
  if (useRemoteConfigFlow) {
    return new RemoteConfigInterstitialStrategy(context, state, config ?? DEFAULT_REMOTE_CONFIG);
  }
  return new LegacyInterstitialStrategy(context, state);
}
